import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import SharedHero from '../../../shared/SharedHero';

const Hero = () => {
  return (
    <SharedHero title="Nous contacter">
      <StaticImage
        src="../../../images/contact/contact.jpg"
        quality={100}
        layout="constrained"
        className="absolute top-0 left-0 h-full w-full object-cover -z-10"
        alt="Contact image"
      />
      <div className="absolute top-0 left-0 h-full w-full object-cover -z-10 gradient-blue-62" />
    </SharedHero>
  );
};

export default Hero;
